import * as React from 'react';
import * as styles from './GoalCanvasView.scss';
import { formatMonthDayYear } from 'owa-datetime';
import { AssetIconAndInput } from 'owa-timestream-asset-sdk';
import { DueDatePicker } from 'owa-timestream-asset-sdk-duedates';
import type { GoalPayload } from '../schema';
import { observer } from 'mobx-react-lite';
import { whatIsYourGoalPlaceholder, setDateLabel } from '../goal.locstring.json';
import classNames from 'classnames';
import DateCountdown from './DateCountdown';
import loc from 'owa-localize';
import useGoalEventSync from '../util/useGoalEventSync';

export default observer(function GoalCanvasView({ payload }: { payload: GoalPayload }) {
    const {
        title,
        dueDate,
        isCompleted,
        patchDate,
        removeDate,
        patchTitle,
        patchIsCompleted,
        currentTitle,
        setCurrentTitle,
    } = useGoalEventSync(payload);

    const datePickerClassName = classNames(styles.datePicker, {
        [styles.datePickerWhenDateIsSet]: !!dueDate,
    });
    const dueDateKey = !!dueDate ? `${formatMonthDayYear(dueDate)}` : '';

    return (
        <div className={styles.goalCanvasView}>
            <AssetIconAndInput
                iconName="Bullseye"
                customIcon={
                    dueDate && (
                        <DateCountdown
                            key={dueDateKey}
                            dueDate={dueDate}
                            isCompleted={isCompleted}
                        />
                    )
                }
                multiline={true}
                placeholderResourceId={whatIsYourGoalPlaceholder}
                initialValue={title}
                currentValue={currentTitle}
                setCurrentValue={setCurrentTitle}
                onCommit={patchTitle}
            />
            <DueDatePicker
                key={dueDateKey}
                className={datePickerClassName}
                chooseDateText={loc(setDateLabel)}
                date={dueDate}
                onDateSelected={patchDate}
                onDateRemoved={removeDate}
                isCompleted={!!isCompleted}
                onIsCompletedChanged={patchIsCompleted}
                hideIcon={!!dueDate}
            />
        </div>
    );
});
